










import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import ThankYouMixins from './mixins';
import { _loadComponent } from '@/services/helper';

@Component({
  components: {
    Countdown: (resolve) => _loadComponent('Countdown/', resolve),
  },
})
export default class ThankYouPage extends mixins(Vue, ThankYouMixins) {}
